import { action } from 'satcheljs';
/**
 * Launches Add Member Group Success Action
 */
export default action('ADD_GROUP_MEMBER_SUCCESS', function (groupSmtp) {
    return {
        groupSmtp: groupSmtp,
    };
});
//# sourceMappingURL=addGroupMemberSuccess.js.map